import { useQuery } from '@tanstack/react-query';

import { getChatStats } from '~/services/SupportService';

export const chatStatsQueryKeys = {
  all: ['chatStats'] as const,
  lists: () => [...chatStatsQueryKeys.all, 'list'] as const,
  list: (filters: GetChatStatsFilters) => [...chatStatsQueryKeys.lists(), filters] as const,
};

interface GetChatStatsFilters {
  agentChatsOnly: boolean;
  hasMessagesOnly: boolean;
  assistantVersion?: 'V1' | 'V2';
  offset: number;
  limit: number;
}

interface UseGetChatStatsParams {
  filters: GetChatStatsFilters;
}

export function useGetChatStats({ filters }: UseGetChatStatsParams) {
  return useQuery({
    queryKey: chatStatsQueryKeys.list(filters),
    queryFn: async () => {
      const { result } = await getChatStats(filters);
      return result;
    },
  });
}
